import auth from "@/services/ExerciseInitAuth"

const list = query =>
  auth.get(`${process.env.VUE_APP_EXERCISE_API}admin/cbrs/`, {
    params: query
  });

const remove = ID => 
  auth.delete(`${process.env.VUE_APP_EXERCISE_API}admin/cbrs/${ID}/`)

const put = (ID, data) => 
  auth.put(`${process.env.VUE_APP_EXERCISE_API}admin/cbrs/${ID}/`, data)

const get = (ID) =>
  auth.get(`${process.env.VUE_APP_EXERCISE_API}admin/cbrs/${ID}/`)

const create = data =>
  auth.post(`${process.env.VUE_APP_EXERCISE_API}admin/cbrs/`, data);

export default {
  list,
  remove,
  create,
  put,
  get
}
